import { OverviewScreen } from '~/calendar/components/overview-screen/OverviewScreen';

export default OverviewScreen;
